angular.module('dnecom')
    .controller('CartExportModalController', ["$scope", "$uibModalInstance", "storeId", "parameters", "RequestUtils", function ($scope, $uibModalInstance, storeId, parameters, RequestUtils) {
        $scope.exportForm = {
            'separator': 'tab',
            'dateFrom': parameters.filter.dateFrom,
            'dateTo': parameters.filter.dateTo
        };

        $scope.export = function () {
            var url = Routing.generate('carts_export', {
                'id': storeId
            });

            RequestUtils.post(url, _.merge(parameters, {
                'separator': $scope.exportForm.separator,
                'filter': {'dateFrom': $scope.exportForm.dateFrom, 'dateTo': $scope.exportForm.dateTo }
            }));

            $scope.closeModal();
        };

        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };
    }]);
